export default __webpack_public_path__ + "banner_m218f94a.jpg";